import { render, staticRenderFns } from "./Burn.vue?vue&type=template&id=5ff0e8a6&scoped=true&"
import script from "./Burn.vue?vue&type=script&lang=js&"
export * from "./Burn.vue?vue&type=script&lang=js&"
import style0 from "./Burn.vue?vue&type=style&index=0&id=5ff0e8a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0e8a6",
  null
  
)

export default component.exports